import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

import { type TemporarySession, submitUserRegistration } from '@asset-solutions/customer-portal/auth/data-access';
import { ColorMode } from '@asset-solutions/shared/ui';
import { Store } from '@ngrx/store';

import { NewPasswordComponent } from '../new-password/new-password.component';
import { SplashPageComponent } from '../splash-page.component';

@Component({
  selector: 'auth-register-user',
  imports: [FormsModule, MatInputModule, MatButton, SplashPageComponent, NewPasswordComponent],
  templateUrl: './register-user.component.html',
  styleUrl: './register-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterUserComponent {
  public readonly temporarySession = input.required<TemporarySession>();
  private readonly store = inject(Store);
  protected readonly colorMode = inject(ColorMode);

  public formData = { name: '', newPassword: '' };

  public submitRegistration(): void {
    this.store.dispatch(
      submitUserRegistration({
        displayName: this.formData.name,
        password: this.formData.newPassword,
        sessionId: this.temporarySession().sessionId
      })
    );
  }
}
